import $ from 'jquery'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import './component.scss'

// ルートクラス定義
const ROOT_TARGET_CLASS_NAME = 'js-mainvisualSearchWidget-root-target'
const ROOT_TARGET_SELECTOR = `.${ROOT_TARGET_CLASS_NAME}`

const areaSelect = () => {
  // セレクタ定義
  const REGION_GROUP_TARGET_CLASS_NAME = 'js-mainvisualSearchWidget-areaSelect-regionGroup-target'
  const REGION_GROUP_TARGET_SELECTOR = `.${REGION_GROUP_TARGET_CLASS_NAME}`

  const REGION_BUTTON_TARGET_CLASS_NAME = 'js-mainvisualSearchWidget-areaSelect-regionButton-target'
  const REGION_BUTTON_TARGET_SELECTOR = `.${REGION_BUTTON_TARGET_CLASS_NAME}`

  const PREFECTURE_GROUP_TARGET_CLASS_NAME = 'js-mainvisualSearchWidget-areaSelect-prefectureGroup-target'
  const PREFECTURE_GROUP_TARGET_SELECTOR = `.${PREFECTURE_GROUP_TARGET_CLASS_NAME}`

  const BACK_TO_REGION_CONTAINER_TARGET_CLASS_NAME = 'js-mainvisualSearchWidget-areaSelect-backToRegionContainer-target'
  const BACK_TO_REGION_CONTAINER_TARGET_SELECTOR = `.${BACK_TO_REGION_CONTAINER_TARGET_CLASS_NAME}`

  const BACK_TO_REGION_TARGET_CLASS_NAME = 'js-mainvisualSearchWidget-areaSelect-backToRegion-target'
  const BACK_TO_REGION_TARGET_SELECTOR = `.${BACK_TO_REGION_TARGET_CLASS_NAME}`

  // 表示状態のクラス定義
  const SHOW_CLASS_NAME = 'is-show'

  // 処理
  const $rootElement = $(ROOT_TARGET_SELECTOR)

  $rootElement.each((index, root) => {
    const $regionGroupTarget = $(root).find(REGION_GROUP_TARGET_SELECTOR)
    const $regionButtonTarget = $(root).find(REGION_BUTTON_TARGET_SELECTOR)
    const $prefectureGroupTarget = $(root).find(PREFECTURE_GROUP_TARGET_SELECTOR)
    const $backToRegionContainerTarget = $(root).find(BACK_TO_REGION_CONTAINER_TARGET_SELECTOR)
    const $backToRegionTarget = $(root).find(BACK_TO_REGION_TARGET_SELECTOR)

    $regionButtonTarget.on('click', (event) => {
      const $currentButton = $(event.currentTarget)
      const regionId = $currentButton.data('region-id')

      // 地域選択を非表示に
      $regionGroupTarget.hide()

      // 対応する都道府県を表示する
      $prefectureGroupTarget.filter((index, prefectureGroup) => $(prefectureGroup).data('region-id') == regionId).addClass(SHOW_CLASS_NAME)

      // 地域選択に戻るボタンを表示
      $backToRegionContainerTarget.show()
    })

    $backToRegionTarget.on('click', () => {
      // 都道府県を非表示に
      $prefectureGroupTarget.removeClass(SHOW_CLASS_NAME)

      // 地域選択を表示
      $regionGroupTarget.show()

      // 地域選択に戻るボタンを非表示
      $backToRegionContainerTarget.hide()
    })
  })
}

$(() => {
  // エリア選択処理
  areaSelect()
})
